type SectionHeadingProps = {
  index: string;
  eyebrow: string;
  title: string;
  description?: string;
};

export default function SectionHeading({
  index,
  eyebrow,
  title,
  description,
}: SectionHeadingProps) {
  return (
    <div className="flex flex-col gap-5 border-t border-background-300/70 pt-6 md:flex-row md:items-start md:justify-between md:gap-12">
      <div className="max-w-2xl">
        <div className="flex items-center gap-3">
          <span className="font-label text-xs tracking-editorial text-primary-600">{index}</span>
          <span className="font-label text-xs tracking-editorial text-foreground-500">{eyebrow}</span>
        </div>
        <h2 className="mt-3 font-heading text-2xl font-bold leading-tight text-foreground-950 md:text-4xl">
          {title}
        </h2>
      </div>
      {description ? (
        <p className="max-w-sm font-body text-sm leading-relaxed text-foreground-500 md:text-right">
          {description}
        </p>
      ) : null}
    </div>
  );
}